<template>
      
      <!-- Begin page -->
      <div class="content-page">
            <!-- Start content -->
            <div class="content">
                  <div class="container-fluid">
                        
                        <div class="row">
                              <div class="col-12">
                                    <div class="page-title-box">
                                          <h4 class="page-title float-left">考试专区</h4>
                                          <ol class="breadcrumb float-right">
                                                <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                <li class="breadcrumb-item"><a href="#">考试专区</a></li>
                                                <li class="breadcrumb-item active">考试报名</li>
                                          </ol>
                                          
                                          <div class="clearfix"></div>
                                    </div>
                              </div>
                        </div>
                        <!-- end row -->
                        
                        
                        <div class="row">
                              <div class="col-12">
                                    <div class="card-box">
                                          <h4 class="header-title m-t-0">说明</h4>
                                          <p class="text-muted m-b-20 font-13">
                                                以下是您本次考试结果
                                          </p>
                                          
                                          <div class="table-responsive">
                                                <table class="table table-bordered table-striped">
                                                      <thead>
                                                      <tr>
                                                            <th>考试名称</th>
                                                            <th class="text-center">
                                                                  考区
                                                            </th>
                                                            <th class="text-center">
                                                                  考试成绩
                                                            </th>
                                                            
                                                      </tr>
                                                      </thead>
                                                      <tbody>
                                                      <tr>
                                                            <th class="text-nowrap" scope="row">{{term}}</th>
                                                            <td>{{address}}</td>
                                                            <td>缺考</td>
                                                      </tr>
                                                      
                                                      </tbody>
                                                </table>
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <!-- end row -->
                  
                  
                  </div> <!-- container -->
            
            </div> <!-- content -->
      
            <!--footer-->
      
      </div>
      <!-- END wrapper -->


</template>

<script>
      import topbar from './topbar';
      import left from './left';
      import Signup from "./signup";
      import signup_result0 from "./signup_result0";
      import signup_result1 from "./signup_result1";
      import signup_result2 from "./signup_result2";
      import signup_result3 from "./signup_result3";
      export default {
            name: 'main',
            components:{Signup, topbar,left,signup_result0,signup_result1,signup_result2,signup_result3},
            data() {
                  return {
                        status:0,
                        address:'',
                        term:''
                  }
            },
            mounted(){
                  this.show();
            },
            methods: {
                  show: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/signup_result',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {

                              this.status = response.data.status;
                              this.address = response.data.address;
                              this.term = response.data.term;

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}

  
     
</style>



// WEBPACK FOOTER //
// src/components/signup_result0.vue